import { createOperation } from "../operations";

export const sendSurveyOperation = createOperation<void>("SURVEY/SEND_SURVEY");
